import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  LoginInput,
  LoginResponse,
  RegisterInput,
  User,
  ChangePasswordInput,
  UpdateUserInput,
} from '@/types/auth';

export async function login(input: LoginInput): Promise<LoginResponse> {
  const { data } = await client.post<ApiResponse<LoginResponse>>('/api/v1/auth/login', input);
  return data.data;
}

export async function register(input: RegisterInput): Promise<LoginResponse> {
  const { data } = await client.post<ApiResponse<LoginResponse>>('/api/v1/auth/register', input);
  return data.data;
}

export async function me(): Promise<User> {
  const { data } = await client.get<ApiResponse<User>>('/api/v1/auth/me');
  return data.data;
}

export async function updateProfile(input: UpdateUserInput): Promise<User> {
  const { data } = await client.put<ApiResponse<User>>('/api/v1/auth/me', input);
  return data.data;
}

export async function changePassword(input: ChangePasswordInput): Promise<void> {
  await client.post('/api/v1/auth/change-password', input);
}
